import { render, staticRenderFns } from "./ResolDeltaSolMX_2d11.vue?vue&type=template&id=4fccdbe8&"
import script from "./ResolDeltaSolMX_2d11.vue?vue&type=script&lang=js&"
export * from "./ResolDeltaSolMX_2d11.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports